import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TypeaheadPayload, TypeaheadResponse } from '../models/payload';

@Injectable({
  providedIn: 'root'
})
export class TypeaheadService {

  private http = inject(HttpClient);

  getBookingContainerTypeahead(payload:TypeaheadPayload): Observable<TypeaheadResponse[]> {
    return this.http.post<TypeaheadResponse[]>(
      environment.baseUrl + 'Common/typeahead-by-field', payload
    );
}
}
